import axios from 'axios';
import occConfig from '@/api/instances/occ.config';

const url = occConfig.url.BASE_URL;

const tokensInstance = axios.create({baseURL: url});

export default tokensInstance;
